import { render, staticRenderFns } from "./ColophonMusic.vue?vue&type=template&id=5cf0e77c&scoped=true"
import script from "./ColophonMusic.vue?vue&type=script&lang=js"
export * from "./ColophonMusic.vue?vue&type=script&lang=js"
import style0 from "./ColophonMusic.vue?vue&type=style&index=0&id=5cf0e77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0e77c",
  null
  
)

export default component.exports